import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import LocationName from "../../components/location/LocationDetail/LocationName.tsx";
import {useLocationFormState} from "../../components/location/LocationForm/LocationUpdateForm";
import LocationUpdateFormProvider from "../../components/location/LocationForm/LocationUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const LocationUpdateEditPage = () => {
    
    useTitle(t`Update Location`);

    const { locationId: id } = useParams();
    
    return (
        <Box data-testid="Location-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="Location-update-title"
                    >
                        <Trans>Edit Location</Trans>:  <LocationName id={id}/>
                    </Typography>
                    <LocationUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default LocationUpdateEditPage;
